
























































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import axios from 'axios';
import { api } from '@/api';
import { Babysitter, Balance } from '@/interfaces/Models';
import { Debounce } from 'lodash-decorators';
import { Action, Getter } from 'vuex-class';
import BabysitterVacationsCalendar from '@/components/dashboard/admin/babysitter/BabysitterVacationsCalendar.vue';
import NotificationFormDialog from '@/components/dashboard/shared/components/Notification/NotificationFormDialog.vue';
import { debounce } from 'lodash';
import VueI18n from 'vue-i18n';

@Component({
  components: {
    BabysitterVacationsCalendar,
    NotificationFormDialog,
  },
})
export default class BabysitterTable extends Vue {
  public selected = [];
  public showSelect = false;
  public showNotificationDialog = false;
  public showFieldSelector = false;
  public showFilters = true;

  public babysitterRates: any[] = [];
  public babysitterRate: any = {};
  public babysitterId: number = 0;
  public babysittersBalance: string = 'RSD 0';

  public allFields: string[] = [
    'full_name',
    'date_of_birth',
    'contact',
    'address.city.name',
    'address.area_name',
    'experience',
    'balance.formatted_balance',
    'rate.formatted_rate',
    'availability',
    'animator',
    'email',
    'full_time_hours',
    'part_time_hours',
    'salary_range_min',
    'training_passed',
    'years_of_experience',
    'actions',
  ];

  public selectedFields: string[] = [
    'full_name',
    'date_of_birth',
    'contact',
    'address.city.name',
    'address.area_name',
    'experience',
    'balance.formatted_balance',
    'rate.formatted_rate',
    'availability',
    'animator',
    'years_of_experience',
    'documents',
    'actions',
  ];

  public toggleField(field: string) {
    if (this.selectedFields.includes(field)) {
      this.selectedFields = this.selectedFields.filter((f) => f !== field);
    } else {
      this.selectedFields.push(field);
    }
    this.saveSelectedFieldsToLocalStorage();
  }

  public saveSelectedFieldsToLocalStorage() {
    localStorage.setItem(
      'babysitterSelectedFields',
      JSON.stringify(this.selectedFields)
    );
  }

  public loadSelectedFieldsFromLocalStorage() {
    const savedFields = localStorage.getItem('babysitterSelectedFields');
    if (savedFields) {
      this.selectedFields = JSON.parse(savedFields);
    }
  }

  public openFieldSelector() {
    this.showFieldSelector = true;
  }

  public applyFieldSelection() {
    this.saveSelectedFieldsToLocalStorage();
    this.showFieldSelector = false;
  }

  public availabilityOptions: Array<{
    text: string | VueI18n.TranslateResult;
    value: string;
  }> = [];

  public availabilityTypeOptions: Array<{
    text: string | VueI18n.TranslateResult;
    value: string;
  }> = [];

  created() {
    this.initializeAvailabilityOptions();
    this.initializeAvailabilityTypeOptions();
  }

  initializeAvailabilityOptions() {
    this.availabilityOptions = [
      { text: this.$t('babysitters.availability.mornings'), value: 'mornings' },
      {
        text: this.$t('babysitters.availability.afternoons'),
        value: 'afternoons',
      },
      { text: this.$t('babysitters.availability.evenings'), value: 'evenings' },
      { text: this.$t('babysitters.availability.weekends'), value: 'weekends' },
      {
        text: this.$t('babysitters.availability.sleepovers'),
        value: 'sleepovers',
      },
      {
        text: this.$t('babysitters.availability.traveling'),
        value: 'traveling',
      },
    ];
  }

  initializeAvailabilityTypeOptions() {
    this.availabilityTypeOptions = [
      {
        text: this.$t('babysitters.availability.full_time'),
        value: 'full_time',
      },
      {
        text: this.$t('babysitters.availability.part_time'),
        value: 'part_time',
      },
    ];
  }

  public babysitterData: Babysitter = {
    id: 0,
    full_name: '',
    contact: '',
    date_of_birth: '',
    bank_account: '',
    training_passed: false,
    driving_license: false,
    active_driver: false,
    smoker: false,
    animator: false,
    additional_info: '',
    total_earned: 0,
    total_hours: 0,
    total_paid: 0,
    total_unpaid: 0,
  };

  public babysitterLanguages: any[] = [];

  public balance: Balance = {
    id: 0,
    formatted_balance: '',
    hours: 0,
  };

  public address: any = {
    address: '',
    area_name: '',
    city: '',
    district: '',
    postal_code: '',
  };

  public documents: any = {
    court_cert: false,
    cv_en: false,
    cv_sr: false,
    first_aid_cert: false,
    id_card: false,
    police_cert: false,
    psych_test_report: false,
  };

  public earnings: any = {
    data: [],
    total_hours: 0,
  };

  public nativeLanguage: any = {
    name: '',
  };

  public rate: any = {
    hourly_rate: 0,
  };

  public babysitterExperience: any[] = [];

  public dialog: boolean = false;
  public editRateDialog: boolean = false;
  public documentsDialog: boolean = false;
  public calendarDialog: boolean = false;
  public calendarDialogData: number | null = null;

  public totalItems: number = 0;

  public experiences: any[] = [];

  // required for input dialog to popup
  public availabilityCalendarMenu: boolean = false;

  get allHeadersLocalized(): any[] {
    return [
      {
        text: this.$t('table_headers.shared.full_name'),
        value: 'full_name',
      },
      {
        text: this.$t('table_headers.babysitters.date_of_birth'),
        value: 'date_of_birth',
      },
      {
        text: this.$t('table_headers.babysitters.contact'),
        value: 'contact',
      },
      {
        text: this.$t('table_headers.sessions.city'),
        value: 'address.city.name',
      },
      {
        text: this.$t('table_headers.babysitters.area'),
        value: 'address.area_name',
      },
      {
        text: this.$t('table_headers.babysitters.experience'),
        value: 'experience',
      },
      {
        text: this.$t('table_headers.families.balance'),
        value: 'balance.formatted_balance',
      },
      {
        text: this.$t('table_headers.babysitters.rate'),
        value: 'rate.formatted_rate',
      },
      {
        text: this.$t('table_headers.babysitters.availability'),
        value: 'availability',
      },
      {
        text: this.$t('table_headers.babysitters.animator'),
        value: 'animator',
      },
      {
        text: this.$t('table_headers.shared.email'),
        value: 'email',
      },
      {
        text: this.$t('table_headers.babysitters.full_time_hours'),
        value: 'full_time_hours',
      },
      {
        text: this.$t('table_headers.babysitters.part_time_hours'),
        value: 'part_time_hours',
      },
      {
        text: this.$t('table_headers.babysitters.salary_range_min'),
        value: 'salary_range_min',
      },
      {
        text: this.$t('table_headers.babysitters.training_passed'),
        value: 'training_passed',
      },
      {
        text: this.$t('table_headers.babysitters.years_of_experience'),
        value: 'years_of_experience',
        align: 'right',
      },
      {
        text: this.$t('table_headers.babysitters.availability_start_date'),
        value: 'availability_start_date',
      },
      {
        text: this.$t('table_headers.babysitters.documents'),
        value: 'documents',
      },
      {
        text: this.$t('table_headers.shared.actions'),
        value: 'actions',
        align: 'end',
      },
    ];
  }

  get headersLocalized(): any[] {
    return this.allHeadersLocalized.filter((header) =>
      this.selectedFields.includes(header.value)
    );
  }

  public setPayload(babysitter: any) {
    this.babysitterData = {
      id: 0,
      full_name: babysitter.full_name,
      contact: babysitter.contact,
      date_of_birth: babysitter.date_of_birth,
      bank_account: babysitter.bank_account,
      training_passed: babysitter.training_passed,
      driving_license: babysitter.driving_license,
      active_driver: babysitter.active_driver,
      smoker: babysitter.smoker,
      animator: babysitter.animator,
      additional_info: babysitter.additional_info,
      total_earned: babysitter.total_earned,
      total_hours: babysitter.total_hours,
      total_paid: babysitter.total_paid,
      total_unpaid: babysitter.total_unpaid,
    };

    this.address = babysitter.address;
    this.documents = babysitter.documents;
    console.log('Documents', this.documents);
    this.rate = babysitter.rate;
    this.earnings = babysitter.earnings;
    this.balance = babysitter.balance;
    this.babysitterExperience = babysitter.experience.map(
      (exp: any) => exp.description
    );
    this.babysitterLanguages = babysitter.languages;
  }

  public showDialog() {
    this.showNotificationDialog = true;
  }

  public toggleSelect() {
    this.showSelect = !this.showSelect;
    if (!this.showSelect) {
      this.selected = [];
    }
  }

  public showBabysitter(babysitter: Babysitter) {
    this.babysittersLoading = true;

    axios
      .get(api.path('v1.admin.babysitters.single', { id: babysitter.id }))
      .then((res) => {
        this.setPayload(res.data.data);
        this.dialog = true;
      })
      .finally(() => (this.babysittersLoading = false));
  }

  public showBabysitterCalendar(babysitter: Babysitter) {
    this.calendarDialogData = babysitter.id;
    this.calendarDialog = true;
  }

  public showBabysitterDocuments(babysitter: Babysitter) {
    this.$router.push({
      name: 'documents',
      params: { id: babysitter.id.toString() },
    });
  }

  get filters() {
    return {
      babysitter: this.babysitter,
      area: this.area,
      experience: this.experience,
      languages: this.languages,
      activeDriver: this.activeDriver,
      firstAid: this.firstAid,
      vacationDate: this.vacationDate,
      hasUnpaidBalance: this.hasUnpaidBalance,
      isPotentialBabysitter: this.isPotentialBabysitter,
      withDeactivated: this.withDeactivated,
      city: this.city,
      itemsPerPage: this.itemsPerPage,
      availability: this.availability,
      availabilityType: this.availabilityType,
      minSalary: this.minSalary,
    };
  }

  @Watch('filters', { deep: true })
  onFilterValueChange() {
    this.currentPage = 1;
    this.debouncedFetchAndSave();
  }
  @Watch('currentPage')
  onPageChange() {
    if (this.$vuetify.breakpoint.mobile) {
      this.$vuetify.goTo(0);
    }
    this.fetchBabysitters();
  }

  debouncedFetchAndSave = debounce(() => {
    this.fetchBabysitters();
    this.saveFiltersToLocalStorage();
  }, 500);

  saveFiltersToLocalStorage() {
    const filters = {
      babysitter: this.babysitter,
      area: this.area,
      experience: this.experience,
      languages: this.languages,
      activeDriver: this.activeDriver,
      vacationDate: this.vacationDate,
      hasUnpaidBalance: this.hasUnpaidBalance,
      isPotentialBabysitter: this.isPotentialBabysitter,
      withDeactivated: this.withDeactivated,
      city: this.city,
      currentPage: this.currentPage,
      itemsPerPage: this.itemsPerPage,
      availability: this.availability,
      availabilityType: this.availabilityType,
      availabilityTimes: this.availabilityTimes,
    };
    localStorage.setItem('babysitterFilters', JSON.stringify(filters));
  }

  loadFiltersFromLocalStorage() {
    const savedFilters = localStorage.getItem('babysitterFilters');
    if (savedFilters) {
      const filters = JSON.parse(savedFilters);
      this.setBabysitter(filters.babysitter);
      this.setArea(filters.area);
      this.setExperience(filters.experience);
      this.setLanguages(filters.languages);
      this.setActiveDriver(filters.activeDriver);
      this.setVacationDate(filters.vacationDate);
      this.setHasUnpaidBalance(filters.hasUnpaidBalance);
      this.setIsPotentialBabysitter(filters.isPotentialBabysitter || false);
      this.setWithDeactivated(filters.withDeactivated);
      this.setCity(filters.city);
      this.setCurrentPage(filters.currentPage);
      this.setItemsPerPage(filters.itemsPerPage);
      this.setAvailability(filters.availability || []);
      this.setAvailabilityType(filters.availabilityType || []);
      this.setAvailabilityTimes(
        filters.availabilityTimes || {
          mornings: false,
          afternoons: false,
          evenings: false,
          sleepovers: false,
          weekends: false,
          traveling: false,
        }
      );
    } else {
      this.setIsPotentialBabysitter(false);
    }
  }

  // clearFilters() {
  //   this.setBabysitter('');
  //   this.setArea('');
  //   this.setExperience([]);
  //   this.setLanguages([]);
  //   this.setDrivingLicense(false);
  //   this.setVacationDate(null);
  //   this.setHasUnpaidBalance(false);
  //   this.setIsPotentialBabysitter(false);
  //   this.setWithDeactivated(false);
  //   this.setCity('');
  //   this.setCurrentPage(1);
  //   this.setItemsPerPage(10);
  //   localStorage.removeItem('babysitterFilters');
  //   this.fetchBabysitters();
  // }

  @Action('babysitters/setBabysitter') setBabysitter: any;
  @Getter('babysitters/babysitter') babysitterState: any;
  public get babysitter(): string {
    return this.babysitterState;
  }

  public set babysitter(babysitter: string) {
    this.setBabysitter(babysitter);
  }

  @Action('babysitters/setArea') setArea: any;
  @Getter('babysitters/area') areaState: any;
  public get area(): string {
    return this.areaState;
  }

  public set area(area: string) {
    this.setArea(area);
  }

  @Action('babysitters/setExperience') setExperience: any;
  @Getter('babysitters/experience') experienceState: any;
  public get experience(): number[] {
    return this.experienceState;
  }

  public set experience(experience: number[]) {
    this.setExperience(experience);
  }

  @Action('babysitters/setLanguages') setLanguages: any;
  @Getter('babysitters/languages') languagesState: any;
  public get languages(): number[] {
    return this.languagesState;
  }

  public set languages(languages: number[]) {
    this.setLanguages(languages);
  }

  @Action('babysitters/setActiveDriver') setActiveDriver: any;
  @Getter('babysitters/activeDriver') activeDriverState: any;
  public get activeDriver(): boolean | null {
    return this.activeDriverState;
  }

  public set activeDriver(activeDriver: boolean | null) {
    this.setActiveDriver(activeDriver === true ? true : null);
  }

  @Action('babysitters/setFirstAid') setFirstAid: any;
  @Getter('babysitters/firstAid') firstAidState: any;
  public get firstAid(): boolean | null {
    return this.firstAidState;
  }

  public set firstAid(firstAid: boolean | null) {
    this.setFirstAid(firstAid === true ? true : null);
  }

  @Action('babysitters/setVacationDate') setVacationDate: any;
  @Getter('babysitters/vacationDate') vacationDateState: any;
  public get vacationDate(): number {
    return this.vacationDateState;
  }

  public set vacationDate(vacationDate: number) {
    this.setVacationDate(vacationDate);
  }

  @Action('babysitters/setHasUnpaidBalance') setHasUnpaidBalance: any;
  @Getter('babysitters/hasUnpaidBalance') hasUnpaidBalanceState: any;
  public get hasUnpaidBalance(): string {
    return this.hasUnpaidBalanceState;
  }

  public set hasUnpaidBalance(hasUnpaidBalance: string) {
    this.setHasUnpaidBalance(hasUnpaidBalance);
  }

  // Here

  @Action('babysitters/setIsPotentialBabysitter') setIsPotentialBabysitter: any;
  @Getter('babysitters/isPotentialBabysitter') isPotentialBabysitterState: any;
  public get isPotentialBabysitter(): string {
    return this.isPotentialBabysitterState;
  }

  public set isPotentialBabysitter(isPotentialBabysitter: string) {
    this.setIsPotentialBabysitter(isPotentialBabysitter);
  }

  @Action('babysitters/setAvailability') setAvailability: any;
  @Getter('babysitters/availability') availabilityState: any;
  public get availability(): string[] {
    return this.availabilityState;
  }

  public set availability(availability: string[]) {
    this.setAvailability(availability);
  }

  @Action('babysitters/setAvailabilityTimes') setAvailabilityTimes: any;
  @Getter('babysitters/availabilityTimes') availabilityTimesState: any;
  public get availabilityTimes(): { [key: string]: boolean } {
    return this.availabilityTimesState;
  }

  public set availabilityTimes(value: { [key: string]: boolean }) {
    this.setAvailabilityTimes(value);
  }

  public onAvailabilityChange() {
    this.debouncedFetchAndSave();
  }

  @Action('babysitters/setAvailabilityType') setAvailabilityType: any;
  @Getter('babysitters/availabilityType') availabilityTypeState: any;
  public get availabilityType(): string[] {
    return this.availabilityTypeState;
  }

  public set availabilityType(availabilityType: string[]) {
    this.setAvailabilityType(availabilityType);
  }

  @Action('babysitters/setMinSalary') setMinSalary: any;
  @Getter('babysitters/minSalary') minSalaryState: any;
  public get minSalary(): number | null {
    return this.minSalaryState;
  }

  public set minSalary(minSalary: number | null) {
    this.setMinSalary(minSalary);
  }
  @Action('babysitters/setWithDeactivated') setWithDeactivated: any;
  @Getter('babysitters/withDeactivated') withDeactivatedState: any;
  public get withDeactivated(): string {
    return this.withDeactivatedState;
  }

  public set withDeactivated(withDeactivated: string) {
    this.setWithDeactivated(withDeactivated);
  }

  @Action('babysitters/setCity') setCity: any;
  @Getter('babysitters/city') stateCity: any;

  public get city(): string {
    return this.stateCity;
  }

  public set city(city: string) {
    this.setCity(city);
  }

  @Action('babysitters/setCurrentPage') setCurrentPage: any;
  @Getter('babysitters/currentPage') currentPageState: any;
  public get currentPage(): number {
    return this.currentPageState;
  }

  public set currentPage(page: number) {
    this.setCurrentPage(page);
  }

  @Action('babysitters/setItemsPerPage') setItemsPerPage: any;
  @Getter('babysitters/itemsPerPage') itemsPerPageState: any;
  public get itemsPerPage(): number {
    return this.itemsPerPageState;
  }

  public set itemsPerPage(itemsPerPage: number) {
    this.setItemsPerPage(itemsPerPage);
  }

  @Action('babysitters/fetchBabysitters') fetchBabysitters: any;
  @Getter('babysitters/babysitters') babysitters: any;

  @Action('babysitters/setBabysittersLoading') setBabysittersLoading: any;
  @Getter('babysitters/babysittersLoading') babysittersLoadingState: any;

  public get babysittersLoading(): boolean {
    return this.babysittersLoadingState;
  }

  public set babysittersLoading(value: boolean) {
    this.setBabysittersLoading(value);
  }

  @Getter('babysitters/total') total: any;
  @Action('babysitters/clearPayload') clearFilters: any;

  public editBabysitter(babysitter: Babysitter) {
    this.$router.push({
      name: 'edit-babysitter',
      params: { id: babysitter.id.toString() },
    });
  }

  public async editBabysitterRate(babysitter: any) {
    this.babysittersLoading = true;

    if (this.babysitterRates.length <= 0) {
      await this.loadBabysitterRates();
    }

    // this.babysitterRate = babysitter.rate;
    this.babysitterId = babysitter.id;
    this.babysittersLoading = false;
    this.editRateDialog = true;
  }

  public updateRate() {
    this.babysittersLoading = true;

    let payload = {
      rate_id: this.babysitterRate.id,
    };

    axios
      .put(
        api.path('v1.admin.babysitters.updateRate', { id: this.babysitterId }),
        payload
      )
      .then((res) => this.$toast.success(res.data.message))
      .finally(() => {
        this.babysittersLoading = false;
        this.editRateDialog = false;
      });
  }

  @Action('languages/fetchLanguages') fetchLanguages: any;
  @Getter('languages/languages') allLanguages: any;

  @Action('cities/fetchCities') fetchCities: any;
  @Getter('cities/cities') cities: any;

  public async loadExperiences() {
    let params = {
      paginate: 'no',
      order_sort: 'asc',
    };

    await axios
      .get(api.path('v1.admin.experiences'), { params: params })
      .then((res) => (this.experiences = res.data.data));
  }

  public async loadBabysitterRates() {
    await axios
      .get(api.path('v1.admin.babysitterRates'))
      .then((res) => (this.babysitterRates = res.data.data));
  }

  public async fetchBabysittersBalance() {
    await axios
      .get(api.path('v1.admin.babysittersBalance'))
      .then((res) => (this.babysittersBalance = res.data.balance));
  }

  public getAvailabilityString(babysitter: any): string {
    if (babysitter.available_full_time && babysitter.available_part_time) {
      return this.$t('babysitters.availability.both') as string;
    } else if (babysitter.available_full_time) {
      return this.$t('babysitters.availability.full_time') as string;
    } else if (babysitter.available_part_time) {
      return this.$t('babysitters.availability.part_time') as string;
    } else {
      return this.$t('babysitters.availability.none') as string;
    }
  }

  public formatYesNo(value: boolean | number): string {
    if (typeof value === 'boolean') {
      return value ? (this.$t('yes') as string) : (this.$t('no') as string);
    } else if (typeof value === 'number') {
      return value > 0 ? (this.$t('yes') as string) : (this.$t('no') as string);
    }
    return this.$t('no') as string;
  }

  public formatSalary(value: number): string {
    return `${Math.round(value)} EUR`;
  }

  public calculateYearsOfExperience(babysitter: any): number {
    if (babysitter.years_of_experience !== null) {
      return babysitter.years_of_experience;
    }
    const createdAt = new Date(babysitter.created_at);
    const now = new Date();
    const diffInYears =
      (now.getTime() - createdAt.getTime()) / (1000 * 60 * 60 * 24 * 365.25);
    return Math.floor(diffInYears);
  }

  public copyEmail(babysitter: any) {
    if (babysitter.email) {
      navigator.clipboard.writeText(babysitter.email).then(
        () => {
          this.$toast.success(this.$t('messages.email_copied') as string);
        },
        (err) => {
          console.error('Could not copy text: ', err);
          this.$toast.error(this.$t('messages.email_copy_failed') as string);
        }
      );
    } else {
      this.$toast.error(this.$t('messages.no_email_available') as string);
    }
  }

  public copyCvUrl(babysitter: any) {
    const ClipboardItem = (window as any).ClipboardItem;

    if (ClipboardItem) {
      try {
        const item = new ClipboardItem({
          'text/plain': new Promise(async (resolve, reject) => {
            try {
              const response = await axios.post(
                api.path('v1.cv.createIdentifier'),
                {
                  babysitter_id: babysitter.id,
                }
              );
              const identifier = response.data.identifier;
              const url = `${process.env.VUE_APP_WEBSITE}/cv-creator/${identifier}`;
              resolve(new Blob([url], { type: 'text/plain' }));
              this.$toast.success('CV URL copied to clipboard');
            } catch (error) {
              console.error('Could not generate CV URL: ', error);
              this.$toast.error('Failed to generate CV URL');
              reject(error);
            }
          }),
        });
        (navigator.clipboard as any).write([item]);
        return;
      } catch (err) {
        console.warn('ClipboardItem with Promise not supported:', err);
      }
    }

    // Fallback
    this.copyCvUrlLegacy(babysitter);
  }

  public async copyCvUrlLegacy(babysitter: any) {
    try {
      const response = await axios.post(api.path('v1.cv.createIdentifier'), {
        babysitter_id: babysitter.id,
      });
      const identifier = response.data.identifier;
      const url = `${process.env.VUE_APP_WEBSITE}/cv-creator/${identifier}`;
      await navigator.clipboard.writeText(url);
      this.$toast.success('CV URL copied to clipboard');
    } catch (error) {
      console.error('Could not copy CV URL: ', error);
      this.$toast.error('Failed to copy CV URL');
    }
  }

  public async editCv(babysitter: any) {
    const response = await axios.post(api.path('v1.cv.createIdentifier'), {
      babysitter_id: babysitter.id,
    });
    const identifier = response.data.identifier;
    const url = `${process.env.VUE_APP_WEBSITE}/cv-creator/${identifier}`;
    window.open(url, '_blank');
  }

  public copyPsychTestUrl(babysitter: any) {
    const ClipboardItem = (window as any).ClipboardItem;

    if (ClipboardItem) {
      try {
        const item = new ClipboardItem({
          'text/plain': new Promise(async (resolve, reject) => {
            try {
              const response = await axios.post(
                api.path('v1.admin.psychTests.identifier'),
                {
                  user_id: babysitter.user_id,
                }
              );
              const identifier = response.data.identifier;
              const url = `${process.env.VUE_APP_WEBSITE}/psych-test/${identifier}`;
              resolve(new Blob([url], { type: 'text/plain' }));
              this.$toast.success('Psych Test URL copied to clipboard');
            } catch (error) {
              if ((error as any).response?.status === 409) {
                // Already has a test, use the existing identifier
                const identifier = (error as any).response.data.identifier;
                const url = `${process.env.VUE_APP_WEBSITE}/psych-test/${identifier}`;
                resolve(new Blob([url], { type: 'text/plain' }));
                this.$toast.success('Psych Test URL copied to clipboard');
              } else {
                console.error('Could not generate Psych Test URL: ', error);
                this.$toast.error('Failed to generate Psych Test URL');
                reject(error);
              }
            }
          }),
        });
        (navigator.clipboard as any).write([item]);
        return;
      } catch (err) {
        console.warn('ClipboardItem with Promise not supported:', err);
      }
    }

    // Fallback
    this.copyPsychTestUrlLegacy(babysitter);
  }

  public async copyPsychTestUrlLegacy(babysitter: any) {
    try {
      const response = await axios.post(
        api.path('v1.admin.psychTests.identifier'),
        {
          user_id: babysitter.user_id,
        }
      );
      const identifier = response.data.identifier;
      const url = `${process.env.VUE_APP_WEBSITE}/psych-test/${identifier}`;
      await navigator.clipboard.writeText(url);
      this.$toast.success('Psych Test URL copied to clipboard');
    } catch (error) {
      if ((error as any).response?.status === 409) {
        // Already has a test, use the existing identifier
        const identifier = (error as any).response.data.identifier;
        const url = `${process.env.VUE_APP_WEBSITE}/psych-test/${identifier}`;
        await navigator.clipboard.writeText(url);
        this.$toast.success('Psych Test URL copied to clipboard');
      } else {
        console.error('Could not copy Psych Test URL: ', error);
        this.$toast.error('Failed to copy Psych Test URL');
      }
    }
  }

  public downloadDocuments(babysitter: any) {
    this.babysittersLoading = true;
    axios
      .get(
        api.path('v1.admin.babysitters.documents.download', {
          id: babysitter.id,
        }),
        {
          responseType: 'blob',
        }
      )
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${babysitter.full_name}_documents.zip`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.$toast.success(this.$t('messages.documents_downloaded') as string);
      })
      .catch((error) => {
        console.error('Error downloading documents:', error);
        this.$toast.error(
          this.$t('messages.documents_download_failed') as string
        );
      })
      .finally(() => {
        this.babysittersLoading = false;
      });
  }

  public toggleFilters() {
    this.showFilters = !this.showFilters;
  }

  public getDocumentsList(documents: any): string {
    const docList = [];
    if (documents.cv_sr) docList.push('CV_SR');
    if (documents.cv_en) docList.push('CV_EN');
    if (documents.id_card) docList.push('ID');
    if (documents.court_cert) docList.push('CC');
    if (documents.police_cert) docList.push('PC');
    if (documents.first_aid_cert) docList.push('FAC');
    if (documents.psych_test_report) docList.push('PSY');
    return docList.join(', ') || '-';
  }

  public async previewDocument(babysitterId: number, documentType: string) {
    try {
      const response = await axios.get(
        api.path('v1.admin.babysitters.documents', { id: babysitterId })
      );

      const documents = response.data.data;
      let documentUrl = '';

      // Map document type to response field name
      const documentMap: { [key: string]: string } = {
        cv_sr: 'cv_serbian',
        cv_en: 'cv_english',
        id_card: 'id_card',
        court_cert: 'court_cert',
        police_cert: 'police_cert',
        first_aid_cert: 'first_aid_cert',
        psych_test_report: 'psych_test_report',
      };

      const documentField = documentMap[documentType];
      if (documents[documentField]) {
        documentUrl = documents[documentField].src;
      }

      if (documentUrl) {
        window.open(documentUrl);
      } else {
        this.$toast.error(this.$t('messages.document_not_found') as string);
      }
    } catch (error) {
      console.error('Error previewing document:', error);
      this.$toast.error(this.$t('messages.document_open_failed') as string);
    }
  }

  public async mounted() {
    await Promise.all([
      this.fetchCities(),
      this.fetchLanguages(),
      this.loadExperiences(),
      this.fetchBabysittersBalance(),
    ]);
    this.loadFiltersFromLocalStorage();
    this.loadSelectedFieldsFromLocalStorage();
    await this.fetchBabysitters();
    console.log('Babysitters:', this.babysitters);
    console.log('Documents:', this.documents);
  }
}
